import React, { useContext, useEffect, useState } from "react";
import {
  Card,
  message,
  Table,
  Button,
} from "antd";
import "./dashboard.scss";
import { DownOutlined } from "@ant-design/icons";
import dashboardService from "../../services/dashboardService";
import { ThemeContext } from '../../context/themeProvider'

const ROOT = `dashboard_module`

const LeaderBoard = props => {
  const { cardBackgroundColor } = props
  const { setLoading } = useContext(ThemeContext)

  useEffect(() => {
    getLeaderboardDetails()
  }, [])

  const [leaderboardData, setLeaderboard] = useState()

  const getLeaderboardDetails = async () => {
    try {
      setLoading(true)
      const response = await dashboardService.getLeaderBoard()
      // console.log('verify', verifyUser)
      if (response.error) {
        message.destroy()
        message.error(response?.error?.message || 'Something went worng in getting tweets')
      } else {
        setLeaderboard(response?.data)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      return
    }
  }

  const columns = [
    {
      title: 'Rank',
      dataIndex: 'rank',
      width: '25%',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      width: '50%',
      ellipsis: true,
    },
    {
      title: 'Referrals',
      dataIndex: 'referrals',
      width: '25%',
    },
  ]

  const scrollFunc = () => {
    const scroller = document.querySelector('#leader-table')
    console.log('scroller', scroller)
    scroller.addEventListener('scroll', event => {
      console.log('event', event)
    })
  }

  return (
    <Card
      style={{ backgroundColor: `${cardBackgroundColor}` }}
      className={`${ROOT}__tran_ui`}
      title="Leaderboard"
    >
      <div className="card_list px-0 py-0 mb-0">
        <Table
          id="leader-table"
          className={`${ROOT}__table_ui`}
          columns={columns}
          dataSource={leaderboardData?.leaderboardData}
          pagination={false}
          scroll={{
            y: 240,
          }}
          rowKey={record => record.rank}
        />
        {leaderboardData?.userReferralsData && (
          <table className="active_user">
            <tbody key={leaderboardData?.userReferralsData?.rank}>
              <tr>
                <td>{leaderboardData?.userReferralsData?.rank}</td>
                <td>{leaderboardData?.userReferralsData?.email + ' (ME)'}</td>
                <td>{leaderboardData?.userReferralsData?.referrals}</td>
              </tr>
            </tbody>
          </table>
        )}
        {/* <Button type="primary" icon={<DownOutlined />} size="60" className="top_btn" onClick={()=>{scrollFunc()}}/> */}
      </div>
    </Card>
  )
}

export default LeaderBoard;
